import ChainSettings from './ChainSettings';

export default ChainSettings;
